import Newlink from '../index';

export default [
  {
    component: Newlink,
    layout: 'public',
    path: '/new',
  },
];
